import {
  GET_SETTINGS_LOADING,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  SET_SETTINGS_LOADING,
  SET_SETTINGS_SUCCESS,
  SET_SETTINGS_FAILURE,
} from '../actions/settings';

const defaultState = {
  settings: {},
  loading: false,
  error: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_SETTINGS_LOADING:
    case SET_SETTINGS_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case GET_SETTINGS_SUCCESS:
    case SET_SETTINGS_SUCCESS:
      return {
        settings: action.payload,
        loading: false,
        error: false,
      };
    case GET_SETTINGS_FAILURE:
    case SET_SETTINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

const typeToInputType = Object.freeze({
  string: 'text',
  boolean: 'checkbox',
  number: 'number',
  object: 'number', // to support null values of *float64
  array: 'array',
});

const typeToDefaultValue = Object.freeze({
  string: '',
  boolean: false,
  number: 0,
  object: null,
  array: [],
});

export const settingsSelector = (state) => {
  return state.settings.settings;
};

const getSettingRec = (value, path = []) => {
  if (typeof value !== 'object' || value === null || Array.isArray(value)) {
    if (path.length <= 0) {
      throw Error('invalid getSettingRec invocation', value, path);
    }
    const type = Array.isArray(value) ? 'array' : typeof value;
    return {
      // env: ['edgify', ...path].map((s) => s.toUpperCase()).join(' '),
      env: ['edgify', ...path].join('_').toUpperCase(),
      inputType: typeToInputType[type],
      defaultValue: typeToDefaultValue[type],
      lastValue: value,
      // settingsGroupKey,
      // envKey,
      value,
      path, // should not be modified
    };
  }
  // if (value === undefined || value === null) {
  //   console.log(value, path, typeof value);
  // }
  return Object.entries(value)
    .map(([key, v]) => getSettingRec(v, [...path, key]))
    .flat(1);
};

export const settingsArraySelector = (state) => {
  return getSettingRec(settingsSelector(state));
};

export const settingsArrayToObject = (settings) => {
  const result = {};
  settings.forEach((item) => {
    if (item.path.length < 1) {
      throw Error('incorrect settings array item', item);
    }
    let object = result;
    for (let i = 0; i < item.path.length - 1; i++) {
      const p = item.path[i];
      object[p] = object[p] ?? {};
      object = object[p];
    }
    const p = item.path[item.path.length - 1];
    object[p] = item.value;
  });
  return result;
};

export const agentVersionSelector = (state) =>
  state.settings.settings.Agent?.version;
